<template>
  <div class="Economy">
    <div class="des">전비계산기</div>
    
    <div class="exfe">
      <input class="inputValue" placeholder="소비전력을 입력하세요 " type="number" v-model="fe" />
      <div class="inputUnit">Wh / km</div>
    </div>

    <div class="exfe">
      <div class="unit">1kWh로</div>
      <div>{{ fe | numberfe  }}</div>
      <div class="unit">km를 주행하셨습니다.</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Economy",
  data() {
    return {
      address: "",
      fe: 0
    };
  },
  mounted() {},
  filters:{
    numberfe(val){
      if( val == 0 ){
        return 0;
      }
      return (1000 / val).toFixed(1);
    }
  },
  methods: {
    go() {
      var tmpURL = this.address;
      if (tmpURL != "") {
        location.href = "https://www.youtube.com/redirect?q=" + tmpURL;
      } else {
        alert("Please check the URL.");
        this.$refs.address.focus();
      }
    }
  }
};
</script>

<style  scoped>
.Economy {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}


div.des {
  color: #EEEEEE;
  letter-spacing: -1px;
  font-size:60px;
}

div.Economy input {
  position:relative;
  height: 100px;
  width: 800px;
  border: 1px solid #333333;
  margin-bottom: 40px;
  font-size: 60px;
  text-align: center;
  letter-spacing: -0.5px;
  transform: rotate(-0.028deg);
  border-radius: 5px;
  background-color: #ff3333;
  color: #ffffff;
  outline: none;
  font-weight: 200;
}

div.Economy input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 200;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.exfe{
  color:#FFFFFF;
  font-size:100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap:10px;
}
.inputUnit{
  font-size: 50px;
  font-weight: 200;
  padding-bottom:45px;
  color:#999999;
  white-space: nowrap;
}
.unit{
  font-size: 50px;
  font-weight: 200;
  padding-bottom:12px;
  color:#999999;
  white-space: nowrap;

}
</style>



// WEBPACK FOOTER //
// src/pages/Economy/index.vue